import AuthWebModal from 'components/authweb-modal/authweb-modal.component';
import Toast from 'components/toast/toast';
import LoaderComponent from 'components/loader/loader.component';
import IStore from 'models/IStore';
import { ReduxProps } from 'models/ReduxProps';
import React from 'react';
import { connect } from 'react-redux';
import { selectRawErrors } from 'selectors/error/ErrorSelector';
import { selectRequesting } from 'selectors/requesting/RequestingSelector';
import LoginAction from 'stores/login/LoginAction';
import GeolocationModel from 'stores/login/models/login/GeolocationModel';
import ValidateAccountModel from 'stores/login/models/login/ValidateAccountModel';

export interface FormSubmit {
    username: string;
    password: string;
    token: string;
}

interface IProps {
    hanldeSubmitLogin: (data: FormSubmit) => void;
    loadingSubmit: boolean;
    isGeolocation: boolean;
    messageError: string;
    errorPassword: boolean;
    handleChangeErrorPassword: () => void;
}

interface IState {
    submitted: boolean;
    username: string;
    password: string;
    token: string;
    isValidPassword: boolean;
    isValidToken: boolean;
    isDisabled: boolean;
    isValidUserName: boolean;
    isCheckedDataBase: boolean;
    geoModal: boolean;
    isTouched: boolean;
    errorToken: boolean;
    isTouchedToken: boolean;
    maxLengthErrorToken: boolean;
    maxLengthErrorUsername: boolean;
    maxLengthErrorPassword: boolean;
}
interface IStateToProps {
    readonly isRequesting: boolean;
    readonly account: ValidateAccountModel | null;
    readonly selectRawErrors: any;
    readonly geolocation: GeolocationModel;
}
const mapStateToProps = (state: IStore): IStateToProps => ({
    isRequesting: selectRequesting(state, [LoginAction.REQUEST_VALIDATE_ACCOUNT]),
    selectRawErrors: selectRawErrors(state, [LoginAction.REQUEST_VALIDATE_ACCOUNT_FINISHED]),
    account: state.login.account,
    geolocation: state.login.geolocation,
});

class FormLogin extends React.Component<{} & IProps & IStateToProps & ReduxProps<any>, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            submitted: false,
            username: '',
            password: '',
            token: '',
            isValidPassword: false,
            isValidToken: false,
            isDisabled: true,
            isValidUserName: false,
            isCheckedDataBase: true,
            geoModal: false,
            isTouched: false,
            errorToken: false,
            isTouchedToken: false,
            maxLengthErrorToken: false,
            maxLengthErrorUsername: false,
            maxLengthErrorPassword: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handlerKeyUp = this.handlerKeyUp.bind(this);
        this.handleChangeToken = this.handleChangeToken.bind(this);
        this.handlerKeyUpToken = this.handlerKeyUpToken.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangeUserConsent = this.handleChangeUserConsent.bind(this);
        this.handleChangeUserConsentBase = this.handleChangeUserConsentBase.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.errorPassword !== this.props.errorPassword && this.props.errorPassword) {
            this.setState({
                username: '',
                password: '',
                token: '',
                isDisabled: true,
                isValidPassword: false,
                isValidToken: false,
                isValidUserName: false,
                isTouched: false,
            });
        }
    }
    handleOpenModal() {
        this.setState({ geoModal: true });
    }

    handleCloseModal() {
        this.setState({ geoModal: false });
    }

    handleChange(e: React.FormEvent<HTMLInputElement>) {
        this.props.handleChangeErrorPassword();
        const { value } = e.currentTarget;
        // Active user typing
        this.userTyping(e.currentTarget);
        if (value.length) {
            this.setState({ username: value });
        } else {
            this.setState({ username: '' });
        }

        if (this.state.isTouched && value.length < 6) {
            this.setState({ maxLengthErrorUsername: true });
            if (!this.containClass(e.currentTarget, 'error')) {
                e.currentTarget.className += ' error';
            }
        } else {
            this.setState({ maxLengthErrorUsername: false });
        }
    }
    handleChangePassword(e: React.FormEvent<HTMLInputElement>) {
        const { value } = e.currentTarget;
        // Active user typing
        this.userTypingToken(e.currentTarget);
        if (value.length) {
            this.setState({ password: value });
        } else {
            this.setState({ password: '' });
        }
        this.props.handleChangeErrorPassword();
        if (this.state.maxLengthErrorPassword) this.setState({ maxLengthErrorPassword: false });
    }

    handleBlur(e: any) {
        if (e.currentTarget.name === 'username') {
            this.setState({ isTouched: true });
            if (e.currentTarget.value.length < 6) {
                this.setState({ maxLengthErrorUsername: true });
                if (!this.containClass(e.currentTarget, 'error')) {
                    e.currentTarget.className += ' error';
                }
            } else {
                this.setState({ maxLengthErrorUsername: false });
            }
        }

        if (e.currentTarget.name === 'token') {
            this.setState({ isTouchedToken: true });
            if (e.currentTarget.value.length !== 6) {
                this.setState({ maxLengthErrorToken: true });
                if (!this.containClass(e.currentTarget, 'error')) {
                    e.currentTarget.className += ' error';
                }
            } else {
                this.setState({ maxLengthErrorToken: false });
            }
        }
    }

    handlerKeyUp(e: any) {
        var element = e.currentTarget;
        if (element.value.length === 0) {
            this.setState({ isDisabled: true });
            element.className = this.removeClass(element.className, ['user-typing']);
        }
        if (
            this.state.isValidPassword &&
            this.state.isValidToken &&
            this.state.isValidUserName &&
            !this.state.errorToken &&
            !this.state.maxLengthErrorToken &&
            !this.state.maxLengthErrorUsername &&
            !this.state.maxLengthErrorPassword
        ) {
            this.setState({ isDisabled: false });
        } else {
            this.setState({ isDisabled: true });
        }
    }
    handlerKeyUpToken(e: any) {
        var element = e.currentTarget;
        if (element.value.length === 0) {
            this.setState({ isDisabled: true });
            // element.className = this.removeClass(element.className, ['user-typing']);
        } else {
            if (
                this.state.isValidPassword &&
                this.state.isValidToken &&
                this.state.isValidUserName &&
                !this.state.errorToken &&
                !this.state.maxLengthErrorToken &&
                !this.state.maxLengthErrorUsername &&
                !this.state.maxLengthErrorPassword
            ) {
                this.setState({ isDisabled: false });
            } else {
                this.setState({ isDisabled: true });
            }
        }
    }
    handleChangeToken(e: any) {
        const regex = /^[0-9\b]+$/;

        const { name, value } = e.currentTarget;
        // Active user typing
        this.userTypingToken(e.currentTarget);
        if (name.localeCompare('token') === 0) {
            if (value === '' || regex.test(value)) {
                this.setState({ token: value });
                this.setState({ errorToken: false });
            } else {
                this.setState({ errorToken: true });
            }
        } else {
            this.setState({ password: value });
        }

        if (value.length !== 6) {
            this.setState({ maxLengthErrorToken: true });
            if (!this.containClass(e.currentTarget, 'error')) {
                e.currentTarget.className += ' error';
            }
        } else {
            this.setState({ maxLengthErrorToken: false });
        }
        this.props.handleChangeErrorPassword();
    }
    handleSubmit(e: any) {
        e.preventDefault();
        if (this.state.password.length < 8) {
            const element = document.getElementById('password');
            this.setState({ password: '', token: '', isDisabled: true, isValidPassword: false, isValidToken: false });
            this.setState({ maxLengthErrorPassword: true });
            if (element && !this.containClass(element, 'error')) {
                element.className += ' error';
            }
            return;
        }
        if (
            !this.state.isDisabled &&
            this.props.geolocation.userConsent &&
            this.state.isCheckedDataBase &&
            this.state.username !== '' &&
            this.state.password !== '' &&
            this.state.token !== ''
        ) {
            this.props.hanldeSubmitLogin({ username: this.state.username, password: this.state.password, token: this.state.token });
        }
    }
    handleChangeUserConsent(e: any) {
        const checked = e.target.checked;
        this.props.dispatch(LoginAction.SetGeoUserConsent(checked));
    }
    handleChangeUserConsentBase(e: any) {
        const checked = e.target.checked;
        this.setState({ isCheckedDataBase: checked });
    }
    render(): JSX.Element {
        const { messageError } = this.props;
        return (
            <>
                <form action="" className="bbase-tab__panelFXd" onSubmit={this.handleSubmit}>
                    <div className="login-text-header">
                        <p id="FXd__login-header">Inicia Sesión</p>
                    </div>
                    <div className="form-group">
                        <label htmlFor="" placeholder="Usuario" className="label-title">
                            Usuario
                        </label>

                        <input
                            id="username"
                            type="password"
                            onChange={this.handleChange}
                            onKeyUp={this.handlerKeyUp}
                            onBlur={this.handleBlur}
                            name="username"
                            className="form-control"
                            value={this.state.username}
                        />

                        {this.state.isTouched && !this.state.isValidUserName ? (
                            <div className="error-container">*Ingresa un usuario válido</div>
                        ) : this.state.isTouched && this.state.maxLengthErrorUsername ? (
                            <div className="error-container">*El usuario debe tener mínimo 6 caracteres.</div>
                        ) : (
                            <></>
                        )}
                    </div>
                    <div className="form-group">
                        <label htmlFor="" placeholder="Contraseña" className="label-title">
                            Contraseña
                        </label>

                        <input
                            type="password"
                            id="password"
                            onChange={this.handleChangePassword}
                            onKeyUp={this.handlerKeyUp}
                            name="password"
                            className="form-control"
                            value={this.state.password}
                        />
                        {this.state.maxLengthErrorPassword ? <div className="error-container">*Verifica la contraseña ingresada.</div> : <></>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="" placeholder="Token" className="label-title">
                            Token
                        </label>
                        <input
                            type="password"
                            id="token"
                            onChange={this.handleChangeToken}
                            onKeyUp={this.handlerKeyUpToken}
                            onBlur={this.handleBlur}
                            name="token"
                            value={this.state.token}
                            className="form-control"
                        />
                        {this.state.errorToken ? (
                            <div className="error-container">*Este campo solo acepta números.</div>
                        ) : this.state.isTouchedToken && this.state.maxLengthErrorToken ? (
                            <div className="error-container">*El token debe ser de 6 digitos.</div>
                        ) : (
                            <></>
                        )}
                    </div>

                    <div className="form-checkbox">
                        <input
                            type="checkbox"
                            name="consent"
                            id="FXd__input-checkbox"
                            className="custom-checkbox"
                            disabled={this.props.loadingSubmit}
                            checked={this.props.isGeolocation}
                            onChange={this.handleChangeUserConsent}
                        />
                        <label htmlFor="FXd__input-checkbox" className="FXd__label-secondary" />
                        <span onClick={this.handleOpenModal} className="span-geo">
                            Autorizo a Banco Base a acceder a la ubicación de mi dispositivo.
                        </span>
                    </div>
                    <div className="form-checkbox">
                        <input
                            type="checkbox"
                            name="authorization"
                            id="FXd__input-checkbox_2"
                            className="custom-checkbox"
                            disabled={this.props.loadingSubmit}
                            onChange={this.handleChangeUserConsentBase}
                            checked={this.state.isCheckedDataBase}
                        />

                        <label htmlFor="FXd__input-checkbox_2" className="FXd__label-secondary" />
                        <span className="span-checkbox">
                            Autorizo que {''}
                            <a href="ConsentimientoDatos.pdf" target="_blank">
                                mis datos
                            </a>
                            {''} sean integrados a “Valiu”.
                        </span>
                    </div>

                    <AuthWebModal isOpen={this.state.geoModal} onClose={this.handleCloseModal} />

                    <div className="container-button">
                        <button
                            className="btn button-primary-fxd"
                            id="FXd__button-primary"
                            disabled={
                                this.state.isDisabled ||
                                !this.props.geolocation.userConsent ||
                                !this.state.isCheckedDataBase ||
                                this.props.loadingSubmit
                            }
                        >
                            {this.props.loadingSubmit ? <LoaderComponent isActive={true} /> : 'Iniciar Sesión'}
                        </button>
                    </div>

                    {messageError && <label className="error-message">{messageError}</label>}
                </form>
                {!this.state.isCheckedDataBase && (
                    <Toast
                        className={`${!this.props.isGeolocation ? 'authorization' : this.props.geolocation.isBlocked ? 'authorization' : ''}`}
                        type={'authorization'}
                    />
                )}

                {this.props.errorPassword && (
                    <Toast
                        className={`${!this.props.isGeolocation ? 'authorization' : this.props.geolocation.isBlocked ? 'authorization' : ''}`}
                        type={'password'}
                        handleClose={this.props.handleChangeErrorPassword}
                    />
                )}
            </>
        );
    }
    private userTyping(element: any): void {
        if (element.value.length >= 5 && element.value.length <= 20) {
            this.setState({ isValidUserName: true });
            if (this.containClass(element, 'error')) {
                element.className = this.removeClass(element.className, ['error']);
            }
        } else {
            this.setState({ isValidUserName: false });
            if (element.value.length === 0 && this.containClass(element, 'user-typing')) {
                element.className = this.removeClass(element.className, ['user-typing']);
            }
            if (this.containClass(element, 'valid')) {
                element.className = this.removeClass(element.className, ['valid']);
            }
            if (!this.containClass(element, 'error')) {
                element.className += ' error';
            }
        }
    }
    private userTypingToken(element: any): void {
        // SUCCESS
        if (element.value.length > 0 && element.value.length <= 16) {
            // State
            if (element.name === 'password') {
                this.setState({ isValidPassword: true });
            } else {
                this.setState({ isValidToken: true });
            }

            if (this.containClass(element, 'error')) {
                element.className = this.removeClass(element.className, ['error']);
            }
        } else {
            // ERROR
            // State
            if (element.name === 'password') {
                this.setState({ isValidPassword: false });
            } else {
                this.setState({ isValidToken: false });
            }

            // Class
            if (!this.containClass(element, 'error')) {
                element.className += ' error';
            }
        }
    }

    private removeClass(current: any, remove: string[]): any {
        for (const item of remove) {
            return current.replace(item, '').trim();
        }
    }

    private containClass(element: any, value: string): boolean {
        return element.classList.contains(value) ? true : false;
    }
}

export { FormLogin as Unconnected };
export default connect(mapStateToProps)(FormLogin);
